import { render } from "./megaSpinner.vue?vue&type=template&id=4acce8a0&scoped=true&ts=true"
import script from "./megaSpinner.vue?vue&type=script&lang=ts"
export * from "./megaSpinner.vue?vue&type=script&lang=ts"

import "./megaSpinner.vue?vue&type=style&index=0&id=4acce8a0&scoped=true&lang=css"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4acce8a0"]])

export default __exports__